
import { defineComponent } from 'vue';

import ProgressIndicator from '@/components/ProgressIndicator/ProgressIndicator.vue';
import PoweredBy from '@/components/PoweredBy/PoweredBy.vue';
import { Button } from 'mq-ui-kit/lib/Button';
import { FormRow } from 'mq-ui-kit/lib/FormRow';
import YoutubeVideo from '@/components/YoutubeVideo/YoutubeVideo.vue';

import * as Constants from '@/constants';

export default defineComponent({
  name: 'Success',

  components: {
    YoutubeVideo,
    Button,
    PoweredBy,
    FormRow,
    ProgressIndicator,
  },

  data() {
    return {
      facebook: require('@/assets/icons/facebook.svg'),
      instagram: require('@/assets/icons/instagram.svg'),
      tiktok: require('@/assets/icons/tiktok.svg'),

      imageURL: '',
      videoURL: '',
      isVideo: false,
    };
  },

  methods: {
    clickFbMethod() {
      window.open(Constants.MEP_FACEBOOK_URL, '_blank');
    },

    clickInstMethod() {
      window.open(Constants.MEP_INSTAGRAM_URL, '_blank');
    },

    clickTikTokMethod() {
      window.open(Constants.MEP_TIKTOK_URL, '_blank');
    },

    goToMepWebPage() {
      window.open(Constants.MEP_WEB_PAGE_URL, '_self');
    },

    clickOpenAppMethod() {
      const email = this.$store.state.yourdata?.emailAddress;
      const encodedUrl = encodeURIComponent((email as string));

      if (this.$store.state.hasAccountAtMep) {
        const manualLoginUrl = Constants.MAQQIE_CORE_LOGIN_URL.concat(encodedUrl);
        window.open(manualLoginUrl, '_self');
      } else {
        const autoLoginUrl = Constants.MAQQIE_APP_LOGIN_URL_WITH_TOKEN
          .concat(this.$store.state?.token)
          .concat('&username=')
          .concat(encodedUrl)
          .concat('#/auth_redirector');
        window.open(autoLoginUrl, '_self');
      }
    },

    initVideoOrLogo() {
      if (this.$store.state.campaign?.videoUrl) {
        this.isVideo = true;
        this.videoURL = this.$store.state.campaign?.videoUrl;
      }
      this.imageURL = this.$store.state.campaign?.pictureUrl as string;
      return this.isVideo;
    },
  },

  created() {
    this.initVideoOrLogo();
  },
});

